// Generic type guard for checking if a string is a member of a string enum.
export const isEnumValue = <E extends string>(
  value: string,
  enumArg: Record<string, E>,
): value is E => {
  return Object.values(enumArg).includes(value as E);
};
